import gql from 'graphql-tag';
import flightLocation from './flightLocation.fragment.graphql.js';

export default gql`
  ${flightLocation}

  query nearbyFlightLocations($geoPoint: GeoPointInput) {
    flightLocations(geoPoint: $geoPoint) {
      ...FlightLocationFragment
    }
  }
`;
